// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"LandingPage_wrapper__2ngB","img":"LandingPage_img__1XRl","links":"LandingPage_links__1Col"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/LandingPage/LandingPage.scss
// module id = 576
// module chunks = 0